import React from 'react';
import SectionHeader from './SectionHeader';
import CurrencyInput from './CurrencyInput';
import NotesInput from './NotesInput';

/**
 * Section 12 — Legal / Professional
 */
export default function StepLegalProfessional({ data = {}, onChange }) {
  function set(field, value) {
    onChange({ ...data, [field]: value });
  }

  const fields = [
    { key: 'alimony', label: 'Alimony' },
    { key: 'cpa_accountant', label: 'CPA / Accountant' },
    { key: 'other_expenses', label: 'Other Legal / Professional Expenses' },
  ];

  const total = fields.reduce(
    (sum, f) => sum + (Number(data[f.key]) || 0),
    0
  );

  return (
    <div>
      <SectionHeader
        number={12}
        title="Legal / Professional"
        tip="We include HFF investment management fees automatically — you don't
          need to add them here."
      />

      <div className="alert alert-light border small mb-4">
        <strong>Note:</strong> Child Support is captured in the Kids & Education section.
      </div>

      <div className="cashflow-field-grid">
        {fields.map(({ key, label }) => (
          <CurrencyInput
            key={key}
            id={key}
            label={label}
            value={data[key] ?? null}
            onChange={(val) => set(key, val)}
          />
        ))}
      </div>

      {total > 0 && (
        <div className="cashflow-total-box mt-3">
          <span className="fw-semibold">10: Total Legal / Professional</span>
          <span className="cashflow-total-amount">
            ${total.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
          </span>
        </div>
      )}

      <NotesInput value={data.notes} onChange={(val) => set('notes', val)} />
    </div>
  );
}
